import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Setting from './views/Setting'
import Reserve from './views/InShopRservation'
import MenuSelection from './views/InShopRservation/MenuSelection'
import TimeSelection from './views/InShopRservation/TimeSelection.vue'
import CustomerInput from './views/InShopRservation/CustomerInput.vue'
import Confirm from './views/InShopRservation/Confirm.vue'
import Done from './views/InShopRservation/Done.vue'
import BirthdayInput from './views/InShopRservation/BirthdayInput.vue'
import TreatmentSelection from './views/InShopRservation/TreatmentSelection.vue'
import Campaign from './views/InShopRservation/Campaign.vue'
import First from './views/InShopRservation/FirstSelection.vue'
import ScalpCareSelection from './views/InShopRservation/ScalpCareSelection.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/setting',
      name: 'setting',
      component: Setting,
    },
    {
      path: '/first',
      component: First,
    },
    {
      name: 'ReservationTop',
      path: '/reservation/:shopId',
      props: true,
      component: Reserve,
    },
    {
      path: '/reservation/:shopId/campaign',
      name: 'Campaign',
      props: true,
      component: Campaign,
    },
    {
      path: '/reservation/:shopId/menu',
      name: 'MenuSelection',
      props: true,
      component: MenuSelection,
    },
    {
      name: 'TreatmentSelection',
      path: '/reservation/:shopId/menu/:menuId',
      props: true,
      component: TreatmentSelection,
    },
    {
      name: 'ScalpCareSelection',
      path: '/reservation/:shopId/menu/:menuId/scalp_care',
      props: true,
      component: ScalpCareSelection,
    },
    {
      name: 'TimeSelection',
      path: '/reservation/:shopId/menu/:menuId/date/:date/time',
      props: true,
      component: TimeSelection,
    },
    {
      name: 'CustomerInput',
      path: '/reservation/:shopId/menu/:menuId/date/:date/time/:time/customer',
      props: true,
      component: CustomerInput,
    },
    {
      name: 'Confirm',
      path: '/reservation/:shopId/menu/:menuId/date/:date/time/:time/confirm',
      props: true,
      component: Confirm,
    },
    {
      name: 'BirthdayInput',
      path: '/birthday/:customerId',
      props: true,
      component: BirthdayInput,
    },
    {
      name: 'Done',
      path: '/Done',
      props: true,
      component: Done,
    },
    {
      path: '/login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
  ],
})
